import equalByNameAndAssetComponentId from '../../utils/equalByNameAndAssetComponentId';
import dateConverter from '../../../../utils/converters/date.converter';
import {i18n} from "../../../vue-i18n";

export default class ChangeRentDuration {
  constructor(assetComponentId, newEndDate) {
    this.commandName = "ChangeRentDuration";



    this.assetComponentId = assetComponentId;
    this.newEndDate = newEndDate;

    const convertedDate = dateConverter.convertToDate(newEndDate);
    this.description =
      `${i18n.t('CONTENT.date')}: ${i18n.d(convertedDate)}`;
  }

  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: JSON.stringify({
        AssetComponentId: this.assetComponentId,
        NewEndDate: this.newEndDate
      })
    }
  }

  equal = (other) => equalByNameAndAssetComponentId(this, other);
}
